export const processes = {
  name: "Name",
  deleteConfirm: 'Delete process "{process}" ?',
  deleteConfirmText:
    'Do you really want to delete the process "{process}"? You cannot restore this after delete.'
};
